




































































































































































































































































































import { Component, Vue, Inject, Watch, Prop } from "vue-property-decorator";
import { StaffService } from "@/services/staff.service.ts";
import vuedraggable from "vuedraggable";
import FilterSelectBox from '@/shared/mixins/FilterSelectBox';
import ComponentWithGroupShaten from "@/views/components/ComponentWithGroupShaten";

@Component({
  components: {
    draggable: vuedraggable
  },
  mixins: [FilterSelectBox]
})
export default class InspectorSelect extends ComponentWithGroupShaten {
  @Prop({ default: "" })
  title: string;
  public staffService = new StaffService();
  public staffList: any[] = [];
  public checkList: any[] = [];
  private loading: boolean = false;
  timerReOrder: any = null;
  public showEditStaffDialog: boolean = false;
  public staffEditData: any = { staff: [] };
  public roleKbn: number = 0;
  isNotAdmin = true;
  public listStaffEachKyoten: any[] = [];
  public listStaffCdDisplay: any[] = [];
  public listStagingStaffCd: any[] = [];

  chkAllStaffCdLeft: boolean = false;
  chkAllStaffCdRight: boolean = false;
  public orgKyotenCd: any = null;

  public staffOfKyotenList: any[] = [];
  private loadingStaff: boolean = false;

  constructor() {
    super();
  }

  public onSubmit() {
    const tempStaff = this.staffList.map((e: any) => {
      return {
        staffCd: e.staffCd,
        sknWorkRole: e.sknWorkRole
      };
    });
    const data = {
      groupCd: this.form.groupCd,
      shatenCd: this.form.shatenCd,
      kyotenCd: this.form.kyotenSelected,
      staff: tempStaff
    };
    // console.log("onSubmit", JSON.parse(JSON.stringify(data)));
    this.staffService.saveStaffRole(data).then((res: any) => {
      if (res && res == 200) {
        this.$message({
          message: "saved!",
          type: "success"
        });
      } else {
        this.$message({
          message: "error!",
          type: "error"
        });
      }
      this.getStaff();
    });
  }

  public async getStaff() {
    this.loading = true;
    const result = await this.staffService.getStaff(this.form);
    this.loading = false;
    if (result) {
      const data = result.map((e: any, index: number) => {
        return {
          staffNm: e.staffNm,
          staffCd: e.staffCd,
          sknWorkRole: e.sknWorkRole,
          displayOrder: e.displayOrder
        };
      });
      this.$set(this, "staffList", data);
    } else {
      this.$set(this, "staffList", []);
      this.$set(this, "listStaffEachKyoten", []);
    }
    this.getStaffEachKyoten();
  }

  onEnd(event: any) {
    if (this.timerReOrder) {
      clearTimeout(this.timerReOrder);
      this.timerReOrder = null;
    }
    this.timerReOrder = setTimeout(() => {
      this.onSubmit();
    }, 1000);
  }

  staffRoleNm() {
    if (this.roleKbn == 1) {
      return "検査員";
    } else if (this.roleKbn == 2) {
      return "整備士";
    } else if (this.roleKbn == 3) {
      return "補助整備士";
    } else if (this.roleKbn == 4) {
      return "フロント";
    }
    return "";
  }

  public async getStaffByRole() {
    this.$set(this, "loadingStaff", true);
    const result = await this.staffService.getStaff(
      this.form,
      this.roleKbn
    );
    if (result) {
      const data = result.map((e: any, index: number) => {
        return {
          staffNm: e.staffNm,
          staffCd: e.staffCd,
          isChecked: e.sknWorkRole.indexOf(this.roleKbn) > -1 ? 1 : 0,
          kyotenNm: e.kyotenNm
        };
      }).filter((item: any) => item.isChecked == 1);
      this.$set(this, "staffEditData", {
        staff: data,
        groupCd: this.form.groupCd,
        shatenCd: this.form.shatenCd,
        kyotenCd: this.form.kyotenCd,
        sknWorkRole: this.roleKbn
      });
    } else {
      this.$set(this, "staffEditData", {
        staff: [],
        groupCd: this.form.groupCd,
        shatenCd: this.form.shatenCd,
        kyotenCd: this.form.kyotenCd,
        sknWorkRole: this.roleKbn
      });
    }
    this.$set(this, "loadingStaff", false);
  }

  editStaff(roleKbn: number) {
    this.roleKbn = roleKbn;
    this.staffEditData = {};
    this.getStaffByRole();
    this.showEditStaffDialog = true;
  }

  updateStaff() {
    const checkList = this.staffEditData.staff.filter(
      (e: any) => e.isChecked == 1
    );
    let tempStaff = checkList.map((e: any) => {
      return { staffCd: e.staffCd };
    });
    this.showEditStaffDialog = false;
    this.staffService
      .saveStaffRole({ ...this.staffEditData, staff: tempStaff })
      .then((res: any) => {
        if (res && res == 200) {
          this.$message({
            message: "保存しました。",
            type: "success"
          });
        } else {
          this.$message({
            message: "エラーが発生しました。",
            type: "error"
          });
        }
        this.staffList = [];
        this.closeDialogStaff();
        this.getStaff();
      });
  }

  public async selectKyoten() {
    this.loading = true;
    const data = this.kyotenDataList.filter(
      (e: any) => e.staffCd === this.form.kyotenCd
    );
    this.getStaff();
  }

  public delay(time: number) {
    setTimeout(() => {
      this.loading = false;
    }, time);
  }

  @Watch("checkList")
  private onListChanged() {
    console.log(this.checkList);
  }

  private created() {
    const loginTypeKbn = localStorage.getItem("loginTypeKbn");
    if (loginTypeKbn === "1" || loginTypeKbn === "10") {
      this.isNotAdmin = false;
    }

    this.getGroupDataList().then(res => {
      this.getShatenDataList().then(res2 => {
        this.getKyotenDataList().then(res3 => {
            this.form.kyotenCd = localStorage.getItem("kyotenCd");
            this.getStaff();
        });
      });
    });
  }

  onClickChAllLeft() {
    if (this.chkAllStaffCdLeft) {
      this.listStagingStaffCd = [...this.listStaffCdDisplay];
    } else if (!this.chkAllStaffCdLeft) {
      this.listStagingStaffCd = [];
    }
  }

  public async getStaffEachKyoten() {
    this.loading = true;
    const result = await this.staffService.getStaffEachKyoten(this.form);
    this.loading = false;
    if (result) {
      const data = result.map((e: any, index: number) => {
        return {
          groupCd: e.groupCd,
          shatenCd: e.shatenCd,
          kyotenCd: e.kyotenCd,
          kyotenNm: e.kyotenNm,
          vKyotenNm: e.kyotenNm + '(' + e.kyotenCd + ')',
          staffVOList: e.staffVOList
        };
      });
      this.$set(this, "listStaffEachKyoten", data);
    } else {
      this.$set(this, "listStaffEachKyoten", []);
    }
  }

  onChangeKyotenLeft() {
    const data = this.listStaffEachKyoten[this.orgKyotenCd].staffVOList.map((e: any, index: number) => {
      const checkStaff = this.staffEditData.staff.filter((filterStaff: any)=> {
        return filterStaff.staffCd == e.staffCd && filterStaff.isChecked == 1;
      });
      return {
        staffNm: e.staffNm,
        staffCd: e.staffCd,
        kyotenNm: e.kyotenNm,
        isChecked: checkStaff.length > 0 ? 1 : 0
      };
    });

    this.$set(this, "staffOfKyotenList", data);
  }

  onChangeStaging(staff: any) {
    console.log("onChangeStaging => ", staff);
    if(staff.isChecked) {
      this.staffEditData.staff.push(staff);
    } else {
      this.staffEditData.staff = this.staffEditData.staff.filter(
        (filterStaff: any) => filterStaff.staffCd !== staff.staffCd
      );
    }

  }
  closeDialogStaff() {
    this.showEditStaffDialog = false;
    this.$set(this, "staffOfKyotenList", []);
    this.orgKyotenCd = null;
  }
}
